import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { AddUserToOrganization, AddUserToOrganizationVariables } from "./__generated__/AddUserToOrganization";
import { ORG_USER_FIELDS } from "../fragments/OrgUser";
import { getErrors } from "../../utils";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";

const ADD_USER_TO_ORGANIZATION = gql`
  ${ORG_USER_FIELDS}
  ${CORE_LICENCE_FIELDS}
  mutation AddUserToOrganization(
    $userId: String!
    $organizationId: String!
    $adminRoleId: String
    $licenceId: String
    $phoneNumber: String
    $calibrationCertificate: CalibrationCertificateInput
    $orgUserFiles: [OrgUserFileInput]
  ) {
    addUserToOrganization(
      input: {
        userId: $userId
        organizationId: $organizationId
        adminRoleId: $adminRoleId
        licenceId: $licenceId
        phoneNumber: $phoneNumber
        calibrationCertificate: $calibrationCertificate
        orgUserFiles: $orgUserFiles
      }
    ) {
      orgUser {
        ...OrgUserFields
        orgUserFiles {
          id
          title
          expiryDate
          fileUrl
        }
        licenceId
        licence {
          ...CoreLicenceFields
        }
        organization {
          activeLicences {
            availableUserSlots
          }
        }
      }
    }
  }
`;

export function useAddUserToOrganization() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddUserToOrganization,
    AddUserToOrganizationVariables
  >(ADD_USER_TO_ORGANIZATION, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
